/**
 * Expand a compressed scholarship applications API response back into the
 * shape expected by existing UI components.
 * @param {{
 *   data: Array<Record<string, any>>,
 *   schools?: Array<{ id: number, n: string }>,
 *   terms?: Array<{ id: number, d: string }>,
 *   statuses?: Array<{ id: number, d: string, c: string }>,
 *   totalCount?: number
 * }} response
 * @returns {Array<Record<string, any>>}
 */
export function expandScholarshipApplications(response) {
    if (!response?.data?.length) {
        return [];
    }

    const schoolMap = new Map((response.schools || []).map((school) => [school.id, school]));
    const termMap = new Map((response.terms || []).map((term) => [term.id, term]));
    const statusMap = new Map((response.statuses || []).map((status) => [status.id, status]));
    const totalCount = response.totalCount ?? 0;

    return response.data.map((row) => {
        const school = schoolMap.get(row.s);
        const term = termMap.get(row.t);
        const status = statusMap.get(row.st);
        const firstName = row.f ?? '';
        const lastName = row.ln ?? '';

        return {
            UniqueID: row.u,
            ApplicationInstanceId: row.a,
            ApplicationStartUTC: row.as,
            ApplicationTypeId: row.at,
            Username: row.un ?? '',
            DOB: row.d,
            LastUpdatedUTC: row.lu,
            Legacy: !!row.l,
            StudentFirstName: firstName,
            StudentLastName: lastName,
            StudentName: `${firstName} ${lastName}`.trim(),
            SchoolId: row.s,
            SchoolName: school?.n ?? '',
            Status: status
                ? {
                      id: status.id,
                      description: status.d,
                      displayColor: status.c,
                  }
                : undefined,
            TermDescription: term?.d ?? '',
            TermID: row.t,
            TotalRecordCount: totalCount,
            ReviewFlag: !!row.rf,
            NotificationEmailLocation: row.ne,
        };
    });
}
